import { render, staticRenderFns } from "./FormVoucher.vue?vue&type=template&id=d66f6438"
import script from "./FormVoucher.vue?vue&type=script&lang=js"
export * from "./FormVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/Input.vue').default,Field: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/field/Field.vue').default,InputCurrency: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/templates/currency/InputCurrency.vue').default,DevDebug: require('/home/runner/work/platform/platform/packages/client/src/components/utils/dev-debug/DevDebug.vue').default,Form: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/form/Form.vue').default})
